import { render } from "./FreedomPayOrders.vue?vue&type=template&id=5ba2440c"
import script from "./FreedomPayOrders.vue?vue&type=script&lang=js"
export * from "./FreedomPayOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__